// Styles for LegalTextArea go here.
import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledLegalTextArea = styled.div`
  ${rtl`
    &.m-text-area {
      position: relative;
      box-sizing: border-box;

      textarea {
        width: 100%;
        padding: ${toRem(12)} ${toRem(0)} ${toRem(12)} ${toRem(16)};
        border: ${baseVariables.color.neutral40} solid ${toRem(1)};
        border-radius: ${toRem(4)};
        background-color: transparent;

        &:focus {
          border-color: var(--t-brand-fg-color);
          box-shadow: 0 0 0 ${toRem(0.5)} inset;
        }
      }

      label {
        position: absolute;
        top: ${toRem(-7.52)};
        left: ${toRem(11)};
        font-size: ${toRem(14)};
        text-transform: capitalize;
        background: ${baseVariables.color.base20};
        padding: 0 ${toRem(6)};
        font-weight: 500;
        letter-spacing: 0;
        margin-bottom: 0;
      }

      &.is-error textarea {
        border-color: var(--t-form-error-color) !important;
    }
      &.is-error {
        label,
        .error-text {
          color: var(--t-form-error-color);
      }
`}
`;
